import React, { Fragment } from "react";
import {
    FACHADMIN,
    LESER_BEHOERDE,
    SYSTEMADMIN,
    ZUST_SBA,
    ZUST_SBB,
    ZUST_SBD,
    ZUST_SBS
} from "../../consts/funktionaleRollen";
import routes from "../../consts/routes.json";
import { LOGGED_IN_CONDITION, NOT_LOGGED_IN_CONDITION, userHasAnyRole } from "../../utils/SecurityUtils";
import BetriebsDescriptionComponent from "../betriebsakte/BetriebsDescriptionComponent";
import EARoute from "../EARoute";
import PageNavigationLink from "./PageNavigationLink";

function PageNavigation({ location }) {
    return (
        <nav role="navigation" className="navigation">
            <ul style={{ display: "flex" }} className="level_1">
                {userHasAnyRole(LOGGED_IN_CONDITION) && <PageNavigationLink exact route={routes.STARTSEITE} label="Startseite" />}
                {userHasAnyRole(SYSTEMADMIN) && (location.pathname === "/" || location.pathname.startsWith("/systemverwaltung") || location.pathname.startsWith("/auswertung")) && (
                    <PageNavigationLink
                        route={routes.SYSTEMVERWALTUNG}
                        label="Systemverwaltung"
                        isActive={(match) => match && match.url.startsWith(routes.SYSTEMVERWALTUNG)}
                    />
                )}
                {userHasAnyRole([SYSTEMADMIN, FACHADMIN, LESER_BEHOERDE, ZUST_SBA, ZUST_SBB, ZUST_SBD, ZUST_SBS]) && (location.pathname === "/" || location.pathname.startsWith("/systemverwaltung") || location.pathname.startsWith("/auswertung")) && (
                    <PageNavigationLink
                        route={routes.AUSWERTUNG}
                        label="Auswertung"
                        isActive={(match) => match && match.url.startsWith(routes.AUSWERTUNG)}
                    />
                )}
                {userHasAnyRole(NOT_LOGGED_IN_CONDITION) && (
                    <Fragment>
                        <PageNavigationLink route={routes.LOGIN} label="Login" />
                        <PageNavigationLink route={routes.REGISTRATION} label="Registrieren" />
                    </Fragment>
                )}
                <EARoute path={routes.BETRIEBSAKTE_WITH_ID} component={BetriebsDescriptionComponent} condition={LOGGED_IN_CONDITION} />
            </ul>
        </nav>
    );
}

export default PageNavigation;
